// extracted by mini-css-extract-plugin
export default {"list":"ZggO4o1NLpN2buenbyz3","listItem":"HsHAztpqqSgyhMSbL2P3"};